<template>
  <VisibilityObserver @visible="onVisible" :threshold="0.5">
    <img class="infinite-scroll-image" src="/images/loading.svg" />
  </VisibilityObserver>
</template>

<script>
import VisibilityObserver from '@/components/VisibilityObserver.vue'
import { sleep } from '@/helpers'

export default {
  name: 'AppInfiniteScroll',

  emits: ['process'],

  components: {
    VisibilityObserver,
  },

  props: {
    onProcess: {
      type: Function,
      required: false,
    },

    thresholdOnError: {
      type: Number,
      default: 3000,
    },
  },

  methods: {
    async onVisible(visibilityObserver) {
      try {
        visibilityObserver.unobserve()

        await this.onProcess()
      } catch (error) {
        const { thresholdOnError } = this

        console.error(error)

        if (thresholdOnError > 0) await sleep(thresholdOnError)
      } finally {
        visibilityObserver.observe()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.infinite-scroll-image {
  height: 5em;
}
</style>
